import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { DynamicPropertyGroupEntity } from "../../types/DynamicPropertyGroupEntity";
import { DynamicPropertyGroupDtoToEntity } from "../mappers/DynamicPropertyGroupDtoToEntity";
import { DynamicPropertyGroupEntityToDto } from "../mappers/DynamicPropertyGroupEntityToDto";

const DynamicPropertyGroupApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        DynamicPropertyGroupLoad: builder.query<DynamicPropertyGroupEntity, FormQuery>({
            providesTags: [ResourceName.DYNAMIC_PROPERTY_GROUPS],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.DYNAMIC_PROPERTY_GROUPS}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return DynamicPropertyGroupDtoToEntity(response);
            },
        }),
        DynamicPropertyGroupSave: builder.mutation<DynamicPropertyGroupEntity, FormMutation<DynamicPropertyGroupEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.DYNAMIC_PROPERTY_GROUPS}`;
                const method = "POST";

                const body = DynamicPropertyGroupEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.DYNAMIC_PROPERTY_GROUPS],
        }),
        DynamicPropertyGroupUpdate: builder.mutation<DynamicPropertyGroupEntity, FormMutation<DynamicPropertyGroupEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.DYNAMIC_PROPERTY_GROUPS}/${mutation.data.id}`;
                const method = "PUT";

                const body = DynamicPropertyGroupEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.DYNAMIC_PROPERTY_GROUPS],
        }),
    }),
});

export const { useDynamicPropertyGroupLoadQuery, useDynamicPropertyGroupSaveMutation, useDynamicPropertyGroupUpdateMutation } =
    DynamicPropertyGroupApi;
